function FetchResDesctructure<ResBody>(res: Response): Promise<{ status: number, ok: boolean, body: ResBody }> {
  return new Promise(resolve => res.json()
    .then(json => resolve({
      status: res.status,
      ok: res.ok,
      body: json as ResBody,
    })));
}

export {
  FetchResDesctructure,
}
